/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 7/7/2023
 */

import React, { useState, useEffect } from "react";
import Select from "react-select";
import api from "../../../base/services/ResApi";
import { FormControl } from "@mui/material";

const GroupsDropdown = ({
  orgCode,
  groupId,
  onChange,
  isGrpDisabled,
  selectRef,
  isRequired,
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    if (orgCode) {
      let apprvConfig = {
        headers: {
          Action: "V_ALL_APPR_GRP",
          "Sort-Column": "grp_id",
          "Sort-Order": "asc",
          Filter: "F_ORG_CODE",
          Value: orgCode,
          "Is-Pagination": "false",
        },
      }
      const fetchData = () => {
        api
          .get("/groups", apprvConfig)
          .then((res) => {
            setData(res.data?.dataList)
          })
          .catch((error) => {
            console.log(error)
          })
      }
      fetchData()
    }
  }, [orgCode])

  // Selector
  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "10px",
    }),
  }

  const options = data.map((item) => ({
    value: item.groupId,
    label: item.groupName,
    target: { name: "groupId", value: item.groupId },
  }))

  return (
    <div>
      <p
        style={{
          fontSize: "12px",
          position: "relative",
          top: "-9px",
          left: "10px",
          background: "#fff",
          width: "100px",
          paddingLeft: "5px",
          zIndex: 100,
        }}
      >
        Select Groups
      </p>
      <FormControl
        sx={{
          minWidth: 300,
          zIndex: 90,
          position: "relative",
          top: "-32px",
          height: 0,
        }}
      >
        <Select
          required={isRequired}
          ref={selectRef}
          options={options}
          value={options.find((option) => option.value === groupId)}
          onChange={onChange}
          isDisabled={isGrpDisabled}
          isClearable
          styles={{
            ...customStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // Ensure it appears above other elements
            }),
          }}
          menuPortalTarget={document.body} 
          menuPosition="fixed" 
        />
      </FormControl>
    </div>
  )
}

export default GroupsDropdown;
